/* eslint-disable no-console */
import { push } from 'react-router-redux';
import { notification } from 'antd';
import { delay } from 'redux-saga';
import { put, takeLatest, select } from 'redux-saga/effects';
import { setNotification } from 'utils';
import * as UserActions from '../actions/userActions';
import {
    getUsersApi,
    getUsersGroupsApi,
    getpermissionGroupApi,
    enableStatusUserApi,
    disableStatusUserApi,
    addNewUserApi,
    editUserApi,
    addNewUserGroupApi,
    editUserGroupApi,
} from '../api/userApi';
import * as UserTypes from '../types/userTypes';

const getUser = state => state.user;
const getLayout = state => state.layout;

// L O A D   U S E R S
function* loadUsersSaga() {
    try {
        const user = yield select(getUser);
        const { offset, limit, filters } = user;

        const params = {
            offset,
            limit,
            joins: JSON.stringify(['user-group']),
        };

        if (user.sort !== null) {
            params.sort_by = JSON.stringify({ last_name: user.sort.type === 'asc' ? 1 : -1 });
        } else {
            params.sort_by = JSON.stringify({ created_at: -1 });
        }

        const filterParams = {};

        if (filters.reseller.length !== 0) {
            filterParams.reseller_id = filters.reseller;
        }

        if (filters.name !== '') {
            filterParams.first_name = {
                operator: 'typing',
                value: filters.name,
            };
        }

        if (filters.email !== '') {
            filterParams.email = {
                operator: 'typing',
                value: filters.email,
            };
        }

        if (filters.status) {
            filterParams.status = JSON.parse(filters.status);
        }

        if (filters.userGroupe.length !== 0) {
            filterParams.user_group_id = filters.userGroupe;
        }

        params.filter = JSON.stringify(filterParams);

        const result = yield getUsersApi(params);
        yield put(UserActions.loadUsersRes(result.data));
    } catch (e) {
        console.log(e);
        yield put(UserActions.loadUsersErr());
    }
}

export function* loadUsersWatcher() {
    yield takeLatest(UserTypes.LOAD_USERS, loadUsersSaga);
}
// L O A D   U S E R S

// S E T    D I S A B L E    U S E R
function* setDisableUserSaga(action) {
    try {
        const params = {
            user_id: action.key,
        };

        let result;

        if (action.value) {
            result = yield enableStatusUserApi(params);
        } else {
            result = yield disableStatusUserApi(params);
        }

        yield put(UserActions.setDisableUserRes(result.data));
        yield loadUsersSaga();
    } catch (e) {
        console.log(e);
        yield put(UserActions.loadUsersErr());
    }
}

export function* setDisableUserWatcher() {
    yield takeLatest(UserTypes.SET_DISABLE_USER, setDisableUserSaga);
}
// S E T    D I S A B L E    U S E R


// F I L T E R   R E S E L L E R
function* setResellerFiltersSaga() {
    try {
        const user = yield select(getUser);
        const { offset, limit, filters } = user;

        const params = {
            offset,
            limit,
            joins: JSON.stringify(['user-group']),
        };

        const filterParams = {};

        if (filters.reseller.length !== 0) {
            filterParams.reseller_id = filters.reseller;
        }

        if (filters.name !== '') {
            filterParams.first_name = {
                operator: 'typing',
                value: filters.name,
            };
        }

        if (filters.email !== '') {
            filterParams.email = {
                operator: 'typing',
                value: filters.email,
            };
        }

        if (filters.status) {
            filterParams.status = JSON.parse(filters.status);
        }

        if (filters.userGroupe.length !== 0) {
            filterParams.user_group_id = filters.userGroupe;
        }

        params.filter = JSON.stringify(filterParams);

        const result = yield getUsersApi(params);
        yield put(UserActions.setResellerFiltersRes(result.data));
    } catch (e) {
        console.log(e);
    }
}

export function* setResellerFiltersWatcher() {
    yield takeLatest(UserTypes.SET_RESELLER_FILTER, setResellerFiltersSaga);
}
// F I L T E R   R E S E L L E R

// F I L T E R   U S E R S   N A M E
function* setUserNameFiltersSaga(action) {
    try {
        const user = yield select(getUser);
        const { offset, limit, filters } = user;

        const params = {
            offset,
            limit,
            joins: JSON.stringify(['user-group']),
        };

        const filterParams = {};

        if (filters.name !== '') {
            filterParams.first_name = {
                operator: 'typing',
                value: action.value,
            };
        }

        if (filters.email !== '') {
            filterParams.email = {
                operator: 'typing',
                value: action.value,
            };
        }

        if (filters.status) {
            filterParams.status = JSON.parse(filters.status);
        }

        if (filters.userGroupe.length !== 0) {
            filterParams.user_group_id = filters.userGroupe;
        }

        if (filters.reseller.length !== 0) {
            filterParams.reseller_id = filters.reseller;
        }

        params.filter = JSON.stringify(filterParams);

        const result = yield getUsersApi(params);
        yield put(UserActions.setUserNameFiltersRes(result.data));
    } catch (e) {
        console.log(e);
        yield put(UserActions.loadUsersErr());
    }
}

export function* setUserNameFiltersWatcher() {
    yield takeLatest(UserTypes.SET_USER_NAME_FILTER, setUserNameFiltersSaga);
}
// F I L T E R   U S E R S   N A M E

// F I L T E R   U S E R S   S T A T U S
function* setUserStatusFiltersSaga(action) {
    try {
        const user = yield select(getUser);
        const { offset, limit, filters } = user;

        const params = {
            offset,
            limit,
            joins: JSON.stringify(['user-group']),
        };

        const filterParams = {};

        if (filters.name !== '') {
            filterParams.first_name = {
                operator: 'typing',
                value: filters.name,
            };

            filterParams.status = JSON.parse(action.value);
        } else {
            filterParams.status = JSON.parse(action.value);
        }

        if (filters.email !== '') {
            filterParams.email = {
                operator: 'typing',
                value: filters.email,
            };
        }

        if (filters.userGroupe.length !== 0) {
            filterParams.user_group_id = filters.userGroupe;
        }

        if (filters.reseller.length !== 0) {
            filterParams.reseller_id = filters.reseller;
        }

        params.filter = JSON.stringify(filterParams);

        const result = yield getUsersApi(params);
        yield put(UserActions.setUserStatusFiltersRes(result.data));
    } catch (e) {
        console.log(e);
        yield put(UserActions.loadUsersErr());
    }
}

export function* setUserStatusFiltersWatcher() {
    yield takeLatest(UserTypes.SET_USER_STATUS_FILTER, setUserStatusFiltersSaga);
}
// F I L T E R   U S E R S   S T A T U S

// L O A D   U S E R S   G R O U P S
function* loadUserGroupsSaga() {
    try {
        const user = yield select(getUser);
        const { offset, limit, filters } = user;

        const params = {
            offset,
            limit,
            joins: JSON.stringify(['permission-group']),
        };

        const filterParams = {};

        if (user.sort !== null) {
            params.sort_by = JSON.stringify({ name: user.sort.type === 'asc' ? 1 : -1 });
        } else {
            params.sort_by = JSON.stringify({ created_at: -1 });
        }

        if (window.location.pathname === '/users/groups/') {
            if (filters.permissionName) {
                filterParams.name = {
                    operator: 'typing',
                    value: filters.permissionName,
                };
            }

            if (filters.permissionGroup.length !== 0) {
                filterParams['permissions_groups.permission_group_id'] = filters.permissionGroup;
            }
        }

        params.filter = JSON.stringify(filterParams);

        const result = yield getUsersGroupsApi(params);
        yield put(UserActions.loadUsersGroupsRes(result.data));
    } catch (e) {
        console.log(e);
        yield put(UserActions.loadUsersGroupsErr());
    }
}

export function* loadUserGroupsWatcher() {
    yield takeLatest(UserTypes.LOAD_USERS_GROUPS, loadUserGroupsSaga);
}
// L O A D   U S E R S   G R O U P S


// L O A D   U S E R S   G R O U P S   F O R   U S E R S
function* loadUserGroupsForUsersSaga() {
    try {
        const params = {
            joins: JSON.stringify(['permission-group']),
            limit: 100,
        };

        const result = yield getUsersGroupsApi(params);
        yield put(UserActions.loadUsersGroupsForUsersRes(result.data));
    } catch (e) {
        console.log(e);
        yield put(UserActions.loadUsersGroupsForUsersErr());
    }
}

export function* loadUserGroupsForUsersWatcher() {
    yield takeLatest(UserTypes.LOAD_USERS_GROUPS_FOR_USERS, loadUserGroupsForUsersSaga);
}
// L O A D   U S E R S   G R O U P S  F O R   U S E R S


// F I L T E R   U S E R S   G R O U P S
function* setUserGroupsFiltersSaga() {
    try {
        const user = yield select(getUser);
        const { offset, limit, filters } = user;

        const params = {
            offset,
            limit,
            joins: JSON.stringify(['user-group']),
        };

        const filterParams = {};

        if (filters.name) {
            filterParams.first_name = {
                operator: 'typing',
                value: filters.name,
            };
        }

        if (filters.email !== '') {
            filterParams.email = {
                operator: 'typing',
                value: filters.email,
            };
        }

        if (filters.status) {
            filterParams.status = JSON.parse(filters.status);
        }

        if (filters.userGroupe.length !== 0) {
            filterParams.user_group_id = filters.userGroupe;
        }

        if (filters.reseller.length !== 0) {
            filterParams.reseller_id = filters.reseller;
        }

        params.filter = JSON.stringify(filterParams);

        const result = yield getUsersApi(params);
        yield put(UserActions.setUserGroupsFiltersRes(result.data));
    } catch (e) {
        console.log(e);
        yield put(UserActions.loadUsersGroupsErr());
    }
}

export function* setUserGroupsFiltersWatcher() {
    yield takeLatest(UserTypes.SET_USER_GROUPE_FILTER, setUserGroupsFiltersSaga);
}
// F I L T E R   U S E R S   G R O U P S

// L O A D   P E R M I S S I O N   G R O U P
function* loadPermissionGroupSaga() {
    try {
        const params = {
            limit: 100,
        };

        const result = yield getpermissionGroupApi(params);
        yield put(UserActions.loadPermissionGroupRes(result.data));
    } catch (e) {
        console.log(e);
        yield put(UserActions.loadPermissionGroupErr());
    }
}

export function* loadPermissionGroupWatcher() {
    yield takeLatest(UserTypes.LOAD_PERMISSION_GROUP, loadPermissionGroupSaga);
}
// L O A D   P E R M I S S I O N   G R O U P

// F I L T E R   P E R M I S S I O N   N A M E
function* setPermissionNameFiltersSaga(action) {
    try {
        const user = yield select(getUser);
        const { offset, limit, filters } = user;

        const params = {
            offset,
            limit,
            joins: JSON.stringify(['permission-group']),
        };

        const filterParams = {};

        if (filters.permissionName) {
            filterParams.name = {
                operator: 'typing',
                value: action.value,
            };
        }

        if (filters.permissionGroup.length !== 0) {
            filterParams['permissions_groups.permission_group_id'] = filters.permissionGroup;
        }

        params.filter = JSON.stringify(filterParams);

        const result = yield getUsersGroupsApi(params);
        yield put(UserActions.setPermissionNameFiltersRes(result.data));
    } catch (e) {
        console.log(e);
        yield put(UserActions.loadUsersGroupsErr());
    }
}

export function* setPermissionNameFiltersWatcher() {
    yield takeLatest(UserTypes.SET_PERMISSION_NAME_FILTER, setPermissionNameFiltersSaga);
}
// F I L T E R   P E R M I S S I O N   N A M E

// F I L T E R   P E R M I S S I O N   G R O U P S
function* setPermissionGroupFiltersSaga() {
    try {
        const user = yield select(getUser);
        const { offset, limit, filters } = user;

        const params = {
            offset,
            limit,
            joins: JSON.stringify(['permission-group']),
        };

        const filterParams = {};

        if (filters.permissionName) {
            filterParams.name = {
                operator: 'typing',
                value: filters.permissionName,
            };
        }

        if (filters.permissionGroup.length !== 0) {
            filterParams['permissions_groups.permission_group_id'] = filters.permissionGroup;
        }

        params.filter = JSON.stringify(filterParams);

        const result = yield getUsersGroupsApi(params);
        yield put(UserActions.setPermissionGroupFiltersRes(result.data));
    } catch (e) {
        console.log(e);
        yield put(UserActions.loadUsersGroupsErr());
    }
}

export function* setPermissionGroupFiltersWatcher() {
    yield takeLatest(UserTypes.SET_PERMISSION_GROUP_FILTER, setPermissionGroupFiltersSaga);
}
// F I L T E R   P E R M I S S I O N   G R O U P S

// R E S E T    F I L T E R    U S E R S
function* resetFiltersUsersSaga() {
    try {
        const user = yield select(getUser);
        const { offset, limit } = user;

        const params = {
            offset,
            limit,
            joins: JSON.stringify(['user-group']),
        };

        const result = yield getUsersApi(params);
        yield put(UserActions.resetFiltersUsersRes(result.data));
    } catch (e) {
        yield put(UserActions.loadUsersErr());
    }
}

export function* resetFiltersUsersWatcher() {
    yield takeLatest(UserTypes.RESET_FILTER_USERS, resetFiltersUsersSaga);
}
// R E S E T    F I L T E R    U S E R S

// R E S E T    F I L T E R    U S E R S    G R O U P S
function* resetFiltersUsersGroupsSaga() {
    try {
        const user = yield select(getUser);
        const { offset, limit } = user;

        const params = {
            offset,
            limit,
            joins: JSON.stringify(['permission-group']),
        };

        const result = yield getUsersGroupsApi(params);
        yield put(UserActions.resetFiltersUsersGroupsRes(result.data));
    } catch (e) {
        yield put(UserActions.loadUsersGroupsErr());
    }
}

export function* resetFiltersUsersGroupsWatcher() {
    yield takeLatest(UserTypes.RESET_FILTER_USERS_GROUPS, resetFiltersUsersGroupsSaga);
}
// R E S E T    F I L T E R    U S E R S    G R O U P S

// ////////////////////////////  F O R M  U S E R S ////////////////////////////////////

// A D D   N E W   U S E R S
function* addNewUserSaga(action) {
    const layout = yield select(getLayout);
    const { locale, reseller } = layout;
    const finalDescription = 'user.notification.newUserAddedSuccess';

    try {
        // eslint-disable-next-line no-param-reassign
        action.data.reseller_id = reseller ? reseller.data.hits[0].id : '';
        const result = yield addNewUserApi(action.data);

        if (result.status === 202) {
            yield put(UserActions.addNewUserRes());

            yield put(push('/users/listing/'));

            yield put(UserActions.addNewUserRes(false, true));
            yield delay(1000);
            yield put(UserActions.addNewUserRes(false, false));

            setNotification('success', locale, 'global.success', finalDescription);
        } else {
            const error = yield result.json();

            setNotification('error', locale, 'global.error', error.message, { noTranslateMsg: true });
            yield put(UserActions.addNewUserErr(error.message));
        }
    } catch (e) {
        console.log(e);
        setNotification('error', locale, 'global.error');
        yield put(UserActions.addNewUserErr());
    }
}

export function* addNewUserWatcher() {
    yield takeLatest(UserTypes.ADD_NEW_USER, addNewUserSaga);
}
// A D D   N E W   U S E R S

// L O A D   E D I T A B L E   U S E R S
function* loadEditTableUserSaga(action) {
    try {
        const paramUser = {
            filter: JSON.stringify({
                _id: action.id,
            }),
            joins: JSON.stringify(['user-group']),
        };

        const resultUser = yield getUsersApi(paramUser);

        if (resultUser.data.hits.length === 0) {
            notification.error({
                message: 'Error',
                description: 'User don\'t exist',
            });

            yield put(push('/404'));
            yield put(UserActions.loadUsersErr());
        } else {
            yield put(UserActions.loadEditTableUserRes(resultUser.data.hits[0]));
        }
    } catch (e) {
        console.log(e);
        yield put(UserActions.loadUsersErr());
    }
}

export function* loadEditTableUserWatcher() {
    yield takeLatest(UserTypes.LOAD_EDITTABLE_USER, loadEditTableUserSaga);
}
// L O A D   E D I T A B L E   U S E R S

// E D I T   U S E R S
function* editUserIdSaga(action) {
    const layout = yield select(getLayout);
    const { locale } = layout;
    const finalDescription = 'user.notification.UserEditedSuccess';

    try {
        const result = yield editUserApi(action.data);

        if (result.status === 202) {
            yield put(UserActions.editUserIdRes());

            yield put(UserActions.editUserIdRes(false, true));
            yield delay(500);
            yield put(UserActions.editUserIdRes(false, false));
            yield put(push('/users/listing/'));

            setNotification('success', locale, 'global.success', finalDescription);
        } else {
            const error = yield result.json();

            setNotification('error', locale, 'global.error', error.message, { noTranslateMsg: true });
            yield put(UserActions.editUserIdErr(error.message));
        }
    } catch (e) {
        console.log(e);
        yield put(UserActions.editUserIdErr());
    }
}

export function* editUserIdWatcher() {
    yield takeLatest(UserTypes.EDIT_USER, editUserIdSaga);
}
// E D I T   U S E R S

// ////////////////////////////  F O R M   U S E R S   G R O U P S  ////////////////////////////////////

// A D D   N E W   U S E R S   G R O U P S
function* addNewUserGroupSaga(action) {
    const layout = yield select(getLayout);
    const { locale } = layout;
    const finalDescription = 'userGroup.notification.newUserGroupAddedSuccess';

    try {
        const result = yield addNewUserGroupApi(action.data);

        if (result.status === 202) {
            yield put(UserActions.addNewUserGroupRes());

            yield put(push('/users/groups/'));

            yield put(UserActions.addNewUserGroupRes(false, true));
            yield delay(1000);
            yield put(UserActions.addNewUserGroupRes(false, false));

            setNotification('success', locale, 'global.success', finalDescription);
        } else {
            const error = yield result.json();

            setNotification('error', locale, 'global.error', error.message, { noTranslateMsg: true });
            yield put(UserActions.addNewUserGroupErr(error.message));
        }
    } catch (e) {
        console.log(e);
        setNotification('error', locale, 'global.error');
        yield put(UserActions.addNewUserGroupErr());
    }
}

export function* addNewUserGroupWatcher() {
    yield takeLatest(UserTypes.ADD_NEW_USER_GROUP, addNewUserGroupSaga);
}
// A D D   N E W   U S E R S   G R O U P S

// L O A D   E D I T A B L E   U S E R S   G R O U P S
function* loadEditTableUserGroupSaga(action) {
    try {
        const paramUserGroup = {
            filter: JSON.stringify({
                _id: action.id,
            }),
            joins: JSON.stringify(['permission-group']),
        };

        const resultUserGroup = yield getUsersGroupsApi(paramUserGroup);

        if (resultUserGroup.data.hits.length === 0) {
            notification.error({
                message: 'Error',
                description: 'User don\'t exist',
            });

            yield put(push('/404'));
            yield put(UserActions.loadUsersGroupsErr());
        } else {
            yield put(UserActions.loadEditTableUserGroupRes(resultUserGroup.data.hits[0]));
        }
    } catch (e) {
        console.log(e);
        yield put(UserActions.loadUsersGroupsErr());
    }
}

export function* loadEditTableUserGroupWatcher() {
    yield takeLatest(UserTypes.LOAD_EDITTABLE_USER_GROUP, loadEditTableUserGroupSaga);
}
// L O A D   E D I T A B L E   U S E R S   G R O U P S

// E D I T   U S E R S   G R O U P S
function* editUserGroupIdSaga(action) {
    const layout = yield select(getLayout);
    const { locale } = layout;
    const finalDescription = 'userGroup.notification.UserGroupEditedSuccess';
    try {
        const result = yield editUserGroupApi(action.data);
        if (result.status === 202) {
            yield put(UserActions.editUserGroupIdRes());

            yield put(push('/users/groups/'));

            yield put(UserActions.editUserGroupIdRes(false, true));
            yield delay(1000);
            yield put(UserActions.editUserGroupIdRes(false, false));

            setNotification('success', locale, 'global.success', finalDescription);
        } else {
            const error = yield result.json();

            setNotification('error', locale, 'global.error', error.message, { noTranslateMsg: true });
            yield put(UserActions.editUserGroupIdErr(error.message));
        }
    } catch (e) {
        console.log(e);
        yield put(UserActions.editUserGroupIdErr());
    }
}

export function* editUserGroupIdWatcher() {
    yield takeLatest(UserTypes.EDIT_USER_GROUP, editUserGroupIdSaga);
}
// E D I T   U S E R S   G R O U P S
